import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ParcellaGiudiziale } from '../../../models/parcella-giudiziale';

@Component({
    selector: '[add_doc_to_parcella]',
  templateUrl: 'add-to-parcella.component.html',
})

export class AddDocumentoToParcellaComponent {
  @Input()
  parcellaGiudiziale: ParcellaGiudiziale;

  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(parcella) {
    this.onClickAddToEntity.emit(parcella);
  }
}
